<template>
	<svg
		width="14"
		height="17"
		viewBox="0 0 14 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M4 12C4 12.5523 4.44772 13 5 13L9 13C9.55228 13 10 12.5523 10 12V7L14 7L7 0L0 7L4 7L4 12ZM0 16C0 15.4477 0.447715 15 1 15L13 15C13.5523 15 14 15.4477 14 16V16C14 16.5523 13.5523 17 13 17L1 17C0.447716 17 0 16.5523 0 16V16Z"
			fill="black"
		/>
	</svg>
</template>

<script>
export default {
	name: "UploadIcon",
};
</script>
